define('models/pages/wishlist/offers/wishlist-results',['require','underscore','chaplin','models/base/model','models/base/collection','./wishlist-result'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection'),
        WishlistResult = require('./wishlist-result');

    var WishlistResults = Collection.extend({
        urlPath: '/api/wishlist-result',
        urlParams: function() {
            var params = {};
            if (this.filterActive) {
                params.active = this.filterActive;
            }
            return params;
        },
        model: WishlistResult,
        initialize: function() {
            Chaplin.Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    return WishlistResults;
});

